import { render } from "./QuizDetail.vue?vue&type=template&id=1ad343ae"
import script from "./QuizDetail.vue?vue&type=script&lang=js"
export * from "./QuizDetail.vue?vue&type=script&lang=js"

import "./QuizDetail.vue?vue&type=style&index=0&id=1ad343ae&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__